import {
  SnippetElement,
  defineElement,
  on,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/util-quantity-picker/util-quantity-picker.ts
var UtilQuantityPicker = class extends SnippetElement {
  addQuantity() {
    for (const input of this.variantQty) {
      const value = parseInt(input.value);
      input.value = (value + 1).toString();
    }
    this.decreaseBtn.classList.replace("cursor-default", "cursor-pointer");
    this.quantitySelectDisplay.textContent = this.variantQty[0].value;
  }
  reduceQuantity() {
    if (parseInt(this.variantQty[0].value) > 1) {
      for (const input of this.variantQty) {
        const value = parseInt(input.value);
        input.value = (value - 1).toString();
      }
      if (parseInt(this.variantQty[0].value) == 1) {
        this.decreaseBtn.classList.replace("cursor-pointer", "cursor-default");
      }
    }
    this.quantitySelectDisplay.textContent = this.variantQty[0].value;
  }
  updateQuantity(element) {
    for (const input of this.variantQty) {
      input.value = element.value;
    }
    this.quantitySelectDisplay.textContent = this.variantQty[0].value;
  }
  updateQuantityDisplay(element) {
    for (const input of this.variantQty) {
      input.value = element.value;
    }
    this.quantitySelectDisplay.textContent = this.variantQty[0].value;
  }
};
__decorateClass([
  queryAll("[data-quantity]")
], UtilQuantityPicker.prototype, "variantQty", 2);
__decorateClass([
  query("[data-decrease]")
], UtilQuantityPicker.prototype, "decreaseBtn", 2);
__decorateClass([
  query("[data-quantity-select-display]")
], UtilQuantityPicker.prototype, "quantitySelectDisplay", 2);
__decorateClass([
  onClick("[data-increase]")
], UtilQuantityPicker.prototype, "addQuantity", 1);
__decorateClass([
  onClick("[data-decrease]")
], UtilQuantityPicker.prototype, "reduceQuantity", 1);
__decorateClass([
  on("change", "[data-quantity]")
], UtilQuantityPicker.prototype, "updateQuantity", 1);
__decorateClass([
  on("input", "[data-quantity]")
], UtilQuantityPicker.prototype, "updateQuantityDisplay", 1);
UtilQuantityPicker = __decorateClass([
  defineElement("util-quantity-picker")
], UtilQuantityPicker);
export {
  UtilQuantityPicker
};
